import {SET_SECURITY_LEVELS} from "../actions/types";

const initialState = {
    securityLevels: [],
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_SECURITY_LEVELS:
            return {
                ...state,
                securityLevels: action.payload
            };
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/securityReducer.js